import type {ComponentType} from 'react';

import type {CoreEntityType} from 'nutshell-core/types';

import {CompanyRegularIcon} from 'shells/icon/svg/company-regular-icon';
import {LeadChevronRegularIcon} from 'shells/icon/svg/lead-chevron-regular-icon';
import {PersonRoundRegularIcon} from 'shells/icon/svg/person-round-regular-icon';

export function getFilterEntityLinksForUser(userId: string, entityType: CoreEntityType): string {
    switch (entityType) {
        case 'accounts':
            return `/companies?fields[accounts]=name,contacts,lastContactedTime,address,accountType,tags&filter[owner][anyAll]=any&filter[owner][data][0][data]=${userId}`;
        case 'contacts':
            return `/people?fields[contacts]=name,lastContactedTime,email,phone,address,tags&filter[owner][anyAll]=any&filter[owner][data][0][data]=${userId}`;
        case 'leads':
            return `/leads?fields[leads]=name,age,value,owner,milestone,confidence,closedTime,sources&filter[owner][anyAll]=any&filter[owner][data][0][data]=${userId}`;
        default:
            return '';
    }
}

export function getEntityIcon(entityType: CoreEntityType): ComponentType<any> {
    switch (entityType) {
        case 'accounts':
            return CompanyRegularIcon;
        case 'contacts':
            return PersonRoundRegularIcon;
        case 'leads':
            return LeadChevronRegularIcon;
    }
}

export function getEntityLinkText(entityType: CoreEntityType): string {
    switch (entityType) {
        case 'accounts':
            return 'Companies';
        case 'contacts':
            return 'People';
        case 'leads':
            return 'Leads';
    }
}
